"use strict";

export default class FleetViewDashboard {
  constructor($q, API) {
    this.$q = $q;
    this.API = API;
  }

  /**
   * @name getOutOfRoutePercertange
   * @desc getOutOfRoutePercertange for Vehcile/Driver.
   * @param
   *   @groupIds
   *   @groupType: Vehicle or Driver
   */
  getOutOfRoutePercertange(groupIds, groupType) {
    let deferred = this.$q.defer();
    let url = "v1/OutOfRoutePercertange";

    let param = [];
    param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
    param.push.apply(param, this.API.getArrayQuery("groupType", groupType));

    if (param.length > 0) {
      url += "?" + param.join("&");
    }

    this.API.get(url)
      .success((res) => {
        deferred.resolve(res);
      })
      .error((err) => {
        console.log("error: ", err);
        deferred.reject(err);
      });

    return deferred.promise;
  }

  /**
   * @name getOutOfRouteRatioReport
   * @desc getOutOfRouteRatioReport for Vehcile/Driver.
   * @param
   *   @weeks: number of weeks to retrieve 
   *   @groupIds
   *   @groupType: Vehicle or Driver
   */
  getOutOfRouteRatioReport(weeks, groupIds, groupType) {
    let deferred = this.$q.defer();
    let url = "v1/OutOfRouteRatioReport";

    let param = [];
    param.push.apply(param, this.API.getArrayQuery("weeks", weeks));
    param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
    param.push.apply(param, this.API.getArrayQuery("groupType", groupType));

    if (param.length > 0) {
      url += "?" + param.join("&");
    }

    this.API.get(url)
      .success((res) => {
        deferred.resolve(res);
      })
      .error((err) => {
        console.log("error: ", err);
        deferred.reject(err);
      });

    return deferred.promise;
  }

  /**
   * @name getOutOfRouteReport
   * @desc getOutOfRouteReport for Vehcile/Driver.
   * @param
   *   @groupIds
   *   @groupType: Vehicle or Driver
   */
  getOutOfRouteReport(groupIds, groupType) {
    let deferred = this.$q.defer();
    let url = "v1/OutOfRouteReport";

    let param = [];
    param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
    param.push.apply(param, this.API.getArrayQuery("groupType", groupType));

    if (param.length > 0) {
      url += "?" + param.join("&");
    }

    this.API.get(url)
      .success((res) => {
        deferred.resolve(res);
      })
      .error((err) => {
        console.log("error: ", err);
        deferred.reject(err);
      });

    return deferred.promise;
  }

  /**
   * @name getRoutesByWeek
   * @desc getRoutesByWeek for Vehcile/Driver.
   * @param
   *   @weeks: number of weeks to retrieve 
   *   @groupIds
   *   @groupType: Vehicle or Driver
   */
  getRoutesByWeek(weeks, groupIds, groupType) {
    let deferred = this.$q.defer();
    let url = "v1/RoutesByWeek";

    let param = [];
    param.push.apply(param, this.API.getArrayQuery("weeks", weeks));
    param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
    param.push.apply(param, this.API.getArrayQuery("groupType", groupType));

    if (param.length > 0) {
      url += "?" + param.join("&");
    }

    this.API.get(url)
      .success((res) => {
        deferred.resolve(res);
      })
      .error((err) => {
        console.log("error: ", err);
        deferred.reject(err);
      });

    return deferred.promise;
  }

  /**
   * @name getSummary
   * @desc get summary for Vehcile/Driver including: unit count, averageOORMiles, averageOORTime, averageOoRString, 
   *   maxOORMiles, maxOORTime and maxOoRString
   * @param 
   *   @groupIds
   *   @groupType: Vehicle or Driver
   */
  getSummary(groupIds, groupType) {
    let deferred = this.$q.defer();
    let url = "v1/Summary";

    let param = [];
    param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
    param.push.apply(param, this.API.getArrayQuery("groupType", groupType));

    if (param.length > 0) {
      url += "?" + param.join("&");
    }

    this.API.get(url)
      .success((res) => {
        deferred.resolve(res);
      })
      .error((err) => {
        console.log("error: ", err);
        deferred.reject(err);
      });

    return deferred.promise;
  }

}

FleetViewDashboard.$inject = ["$q", "FleetViewAPI"];




// WEBPACK FOOTER //
// ./app/alk-fleetview/fleetview.dashboard.js